// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var element = "MobileMenu-module--element--Fdpjk";
export var menuHeader = "MobileMenu-module--menuHeader--pdXox";
export var closeBtn = "MobileMenu-module--closeBtn--B+95k";
export var logo = "MobileMenu-module--logo--cKgiN";
export var menuBody = "MobileMenu-module--menuBody--gTkfa";
export var navMenu = "MobileMenu-module--navMenu--dNGCR";
export var mainMenu = "MobileMenu-module--mainMenu--KTF7C";
export var navList = "MobileMenu-module--navList---c07g";
export var actionsWrapper = "MobileMenu-module--actionsWrapper--LJ3Hp";
export var userMenu = "MobileMenu-module--userMenu--PyDs9";